module.exports = __webpack_public_path__ + "bg_with-white.35pdJKuO.svg";